<ng-container [formGroup]="adminInformation">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h2 class="mb-0 section-heading">Admin Information</h2>
      <mat-slide-toggle class="b-one-switch" formControlName="tax_exempt">Tax Exempt?</mat-slide-toggle>
    </div>
    @if (!isEdit) {
      <div class="form-row">
        <div class="form-group col-12">
          <label for="sales_rep_id" class="custom_label">Sales Rep*</label>
          <ng-select
            id="sales_rep_id"
            [items]="staffs"
            placeholder="Select Sales Rep"
            [closeOnSelect]="true"
            formControlName="sales_rep_id"
            bindLabel="{{coreService.ngSelectBindStaffLabel}}"
            >
          </ng-select>
          <app-validation-error [formGroup]="adminInformation" [controlName]="'sales_rep_id'"></app-validation-error>
        </div>
      </div>
    }

    <!-- <div class="form-row" *ngIf="offices?.length && offices.length > 1">
    <div class="form-group col-12">
      <label for="tenant_id" class="custom_label">
      Office *</label>
      <ng-select
        id="group"
        [items]="offices"
        placeholder="Select Office"
        [closeOnSelect]="true"
        formControlName="tenant_id"
        bindLabel="name"
        (change)="onTenantChange()"
        >
      </ng-select>
      <app-validation-error [formGroup]="adminInformation" [controlName]="'tenant_id'"></app-validation-error>
    </div>
  </div>

  <div class="form-row" *ngIf="subOffices?.length && subOffices.length > 0">
    <div class="form-group col-12">
      <label for="tenant_ids" class="custom_label">
      Additional Offices</label>
      <ng-select
        [multiple]="true"
        id="tenant_ids"
        [items]="subOffices"
        placeholder="Select Additional Offices"
        [closeOnSelect]="true"
        formControlName="tenant_ids"
        bindLabel="name"
        >
      </ng-select>
    </div>
  </div> -->

  <div class="form-row">
    <div class="form-group col-12">
      <label class="custom_label">Default Payment Method</label>
      <!--      <app-select-box-->
      <!--        id="payment_method"-->
      <!--        [name]="'payment_method'"-->
      <!--        [items]="paymentMethods"-->
      <!--        formControlName="payment_method"-->
      <!--        [placeholder]="'Select Payment Method'"-->
      <!--        [selectedItem]="onModelValueChanged?.default_payment_method"-->
    <!--      ></app-select-box>-->
    <ng-select
      [items]="paymentMethods"
      formControlName="payment_method"
      [placeholder]="'Select Payment Method'"
      [closeOnSelect]="true"
      bindLabel="name"
      >
    </ng-select>
  </div>
</div>

<div class="form-row">
  <div class="form-group col-12">
    <label class="custom_label">Terms & Conditions</label>
    <ng-select
      [items]="customerTerms"
      formControlName="term_id"
      [placeholder]="'Select Terms & Conditions'"
      [closeOnSelect]="true"
      bindLabel="name"
      >
    </ng-select>
  </div>
</div>

@if (showPreferredMarkup) {
  <div class="form-row">
    <div class="form-group col-12">
      <label for="markup" class="custom_label">Preferred Mark Up</label>
      <div class="input_with_icon">
        <span class="icon_wrap"><!--<img src="../../../../assets/img/dollar_sign.svg" alt="icon"> --> %</span>
        <input
          currencyMask
          [max]="99999999.99" [options]="currencyMaskOptions"
          type="text" step="0.01" formControlName="markup" id="markup"  class="form-control" placeholder="markup" name="markup">
      </div>
    </div>
  </div>
}


<!--<div class="form-row">
<div class="form-group col-12">
  <label for="tax_class" class="custom_label">Tax Class</label>
  <app-form-select
    id="tax_class"
    [items]="taxAndDiscountClasses"
    [placeholder]="'Tax Class'"
    formControlName="tax_class"
  ></app-form-select>
</div>
</div>


<div class="form-row">
  <div class="form-group col-12">
    <label for="disc_class" class="custom_label">Discount Class</label>
    <app-form-select
      id="disc_class"
      [items]="taxAndDiscountClasses"
      [placeholder]="'Discount Class'"
      formControlName="disc_class"
    ></app-form-select>
  </div>
</div>-->


@if (showLienPeriod) {
  <div class="form-row">
    <div class="form-group col-12">
      <label for="lien_period" class="custom_label">Lien Period</label>
      <div class="input_with_icon">
        <span class="icon_wrap"><!--<img src="../../../../assets/img/dollar_sign.svg" alt="icon"> --> Days</span>
        <input type="number" min="0" formControlName="lien_period" id="lien_period" class="form-control" placeholder="Lien Period" name="lien_period">
      </div>
    </div>
  </div>
}


<div class="form-row">
  <div class="form-group col-12">
    <label class="custom_label">Source</label>
    <!--          <app-select-box-->
    <!--            id="source"-->
    <!--            [name]="'source_id'"-->
    <!--            [items]="sources"-->
    <!--            formControlName="source"-->
    <!--            [placeholder]="'Source'"-->
    <!--            [selectedItem]="onModelValueChanged?.source?.id"-->
  <!--          ></app-select-box>-->
  <ng-select
    [items]="sources"
    formControlName="source"
    [placeholder]="'Source'"
    bindLabel="name"
    >
  </ng-select>
</div>
</div>

<div class="form-row">
  <div class="form-group col-12">
    <label for="risk" class="custom_label">Risk Level</label>
    <div class="input_with_icon">
      <span class="icon_wrap"><img src="../../../../assets/img/dollar_sign.svg" alt="icon"></span>
      <input type="text"
        currencyMask
        [max]="99999999.99" [options]="currencyMaskOptions"
        formControlName="risk_level"
        (keyup)="onValueInput($event)"
        id="risk_level"
        class="form-control"
        placeholder="Risk Level"
        name="risk_level">
    </div>
    <!-- TODO: The 'tickInterval' property no longer exists -->
    <mat-slider
      id="risk"
      class="form-control no-boarder-field b-one-slider"
      discrete [displayWith]="formatLabel"
      step="1000"
      min="0"
      max="1000000"
      #ngSlider><input matSliderThumb formControlName="risk" aria-label="units" (input)="onInputChange({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" />
    </mat-slider>
  </div>
</div>
</div>


</ng-container>
